<template>
  <div>
    <Top class="top"/>
    <div class="l-container">
      <div class="inner">
        <div class="col_menu">
          <div class="col_menu_head">
            <h3 class="col_menu_text">企业文化</h3>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <ul class="wp_listcolumn">
                <li :class="isActive===0?'select':''" @click="culture()">
                  <a><span class="column-name">集团文化</span></a>
                </li>
                <li :class="isActive===1?'select':''" @click="share()">
                  <a><span class="column-name">共享平台</span></a>
                </li>
                <li :class="isActive===2?'select':''" @click="family()">
                  <a><span class="column-name">职工之家</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col_news">
          <div class="col_news_box" v-if="isActive===0">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜企业文化 | 集团文化</span></span>
                </li>
                <li class="col_title">
                  <h2>集团文化</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list listcon">
                <ul>
                  <li v-for="(item,index) in listWord" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'集团文化'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col_news_box" v-if="isActive===1">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜企业文化 | 共享平台</span></span>
                </li>
                <li class="col_title">
                  <h2>共享平台</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list listcon">
                <ul>
                  <li v-for="(item,index) in contactL" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'共享平台'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col_news_box" v-if="isActive===2">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜企业文化 | 职工之家</span></span>
                </li>
                <li class="col_title">
                  <h2>职工之家</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list listcon">
                <ul>
                  <li v-for="(item,index) in partyList" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'职工之家'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <Top v-else style="display: none" />-->
<!--    <div class="bodyAll">-->
<!--      <div class="logo"></div>-->
<!--      <ul>-->
<!--        <li class="first1" @click="jump()"><a>首&nbsp;&nbsp;&nbsp;&nbsp;页</a></li>-->
<!--        <li class="second2" @click="jumpS()"><a>集团概括</a></li>-->
<!--        <li class="third" @click="jumpT()"><a>集团动态</a></li>-->
<!--        <li class="fourth" @click="jumpF()"><a>党建之家</a></li>-->
<!--        <li class="five" @click="jumpFI()"><a>企业文化</a></li>-->
<!--        <li class="six" @click="jumpSI()"><a>联系我们</a></li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    <div class="contain">-->
<!--      <div class="containTop">-->
<!--        <div class="topWord">-->
<!--          <div class="wordLfet">企业文化</div>-->
<!--          <div class="wordRight">您当前所在位置：首页 > 企业文化</div>-->
<!--        </div>-->
<!--        <div style="height: 20px;font-size: 1px;clear: both;"></div>-->
<!--        <div class="listNav">-->
<!--          <div class="nav_list">集团文化</div>-->
<!--&lt;!&ndash;          <div class="nav_right">更多</div>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="navWord">-->
<!--          <div style="height:10px; font-size:1px;"></div>-->
<!--          <ul>-->
<!--&lt;!&ndash;                        <li>测试测试<span>2022-2-22</span></li>&ndash;&gt;-->
<!--            <li v-for="(item,index) in listWord" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'集团文化'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="listNav">-->
<!--          <div class="nav_list">共享平台</div>-->
<!--&lt;!&ndash;          <div class="nav_right">更多</div>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="navWord">-->
<!--          <div style="height:10px; font-size:1px;"></div>-->
<!--          <ul>-->
<!--            <li v-for="(item,index) in contactL" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'共享平台'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="listNav">-->
<!--          <div class="nav_list">职工之家</div>-->
<!--&lt;!&ndash;          <div class="nav_right">更多</div>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="navWord">-->
<!--          <div style="height:10px; font-size:1px;"></div>-->
<!--          <ul>-->
<!--            <li v-for="(item,index) in partyList" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'职工之家'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <FooterHtm style="margin-top: 10px"/>
<!--    <FooterHtm v-else style="display: none" />-->
  </div>
</template>

<script>
import $http  from '../ApI/request'  //$http是在导入时自定义的命名可变的
import Top from '../components/Top'
import FooterHtm from './FooterHtm'
export default {
  name: 'culture',
  components:{
    Top,
    FooterHtm
  },
  data () {
    let jd = localStorage.getItem('cujd');
    if (jd) {
      // console.log("1")
      if (this.$route.params.num) {
        localStorage.setItem('cujd', this.$route.params.num);
      }
    } else {
      // console.log("2")
      localStorage.setItem('cujd',this.$route.params.num)
    }
    return {
      listWord:[],
      contactL:[],
      partyList:[],
      isActive:0,
      num:localStorage.getItem('cujd'),
    }
  },
  mounted() {
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'集团文化',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.listWord = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'共享平台',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.contactL = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'职工之家',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.partyList = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
  },
  methods:{
    culture(){
      this.isActive = 0
    },
    share(){
      this.isActive = 1
    },
    family(){
      this.isActive = 2
    }
    // tabs(){
    //   trs[i].onmouseover = function() {
    //     this.className = "bg"
    //   }
    //   this.className = "second"
    // }
    // skip(){
    //   console.log(111)
    //   this.$router.push({
    //     name:'Party',
    //   })
    // }
  }
}
</script>

<style scoped>
a {
  color: #000;
  text-decoration: none;
  outline: medium none;
}

.l-container {
  width: 100%;
  min-height: 760px;
  margin: 0 auto;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding: 40px 0;
}

.inner {
  padding: 0;
  width: 1300px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
}

.col_menu {
  width: 280px;
  flex-shrink: 0;
}

.col_menu_head {
  background: linear-gradient(to right, #0a3d82, #1e5dbd);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.2);
}

.col_menu_text {
  font-size: 24px;
  color: #fff;
  display: block;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 2px;
}

.col_menu_con {
  background: #f6f6f6;
}

.col_list {
  background: white;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.1);
  padding: 20px 0;
}

.wp_listcolumn {
  margin: 0;
  padding: 0;
  list-style: none;
}

.wp_listcolumn li {
  margin: 0;
  padding: 0;
  position: relative;
}

.wp_listcolumn li a {
  padding: 15px 20px 15px 50px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
  display: block;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.wp_listcolumn li a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(12, 77, 162, 0.1), transparent);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.column-name {
  position: relative;
  padding-left: 25px;
  z-index: 1;
}

.column-name::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background:no-repeat center;
  background-size: contain;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.wp_listcolumn li:hover a::before {
  transform: translateX(0);
}

.wp_listcolumn li:hover a {
  color: #0c4da2;
  padding-left: 55px;
}

.wp_listcolumn li:hover .column-name::before {
  opacity: 1;
  transform: translateY(-50%) scale(1.1);
}

.wp_listcolumn li.select a {
  color: #0c4da2;
  background: rgba(12, 77, 162, 0.1);
  font-weight: bold;
}

.col_news {
  flex: 1;
  min-height: 500px;
}

.col_news_box {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.col_news_box:hover {
  transform: translateY(-5px);
}

.col_news_head {
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  margin-bottom: 30px;
  padding-bottom: 15px;
  position: relative;
}

.col_news_head::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100px;
  height: 2px;
  background: linear-gradient(to right, #0c4da2, #76b6ff);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.col_news_box:hover .col_news_head::after {
  transform: scaleX(1);
}

.col_metas {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.col_path {
  color: #666;
  font-size: 14px;
}

.col_path span span {
  color: #0c4da2;
}

.col_title h2 {
  margin: 0;
  color: #0c4da2;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  display: inline-block;
}

.col_title h2::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #0c4da2, #76b6ff);
  border-radius: 2px;
}

.col_news_con {
  padding: 20px 0;
}

.listcon {
  margin: 0;
  padding: 0;
}

.listcon ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.listcon ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px dashed rgba(12, 77, 162, 0.1);
  transition: all 0.3s ease;
  border-radius: 4px;
  position: relative;
}

.listcon ul li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background: #0c4da2;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s ease;
}

.listcon ul li:hover {
  background: rgba(12, 77, 162, 0.02);
  padding-left: 30px;
}

.listcon ul li:hover::before {
  opacity: 1;
  width: 6px;
  height: 6px;
}

.listcon ul li a {
  flex: 1;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 20px;
  transition: all 0.3s ease;
}

.listcon ul li:hover a {
  color: #0c4da2;
}

.listcon ul li span {
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

@media screen and (max-width: 750px) {
  .inner {
    width: 95%;
    flex-direction: column;
    gap: 20px;
  }

  .col_menu {
    width: 100%;
  }

  .col_menu_text {
    font-size: 20px;
    line-height: 50px;
  }

  .col_list {
    padding: 10px;
  }

  .wp_listcolumn li a {
    padding: 12px 15px 12px 40px;
    font-size: 14px;
  }

  .col_news_box {
    padding: 15px;
  }

  .col_metas {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .col_title h2 {
    font-size: 20px;
  }

  .listcon ul li {
    padding: 12px 0;
  }

  .listcon ul li a {
    font-size: 14px;
  }

  .listcon ul li span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Culture.vue